import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  option:{
    fontSize: '0.75rem',
  },
  formControl: {
    maxWidth: 300,
    margin: '0px',
    marginTop: '18px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const Tier = ({
  onChange,
  disabled,
  error,
  title,
  tier,
  tier_variations,
  tier_brands,
  display,
  ...props
}) => {


const handleChange = event => {
  onChange(event, 'tiers')
}

const handleTierChange = (e, values) => {
  //e.target.value = values
  //onChange()
  e.target.value = ''
  if (values){
    e.target.value = values.id
  } else {
    e.target.id = tier.tier_type_id + ".tier_variation_id-option"
    e.target.name = tier.tier_type_id + ".tier_variation_id-option"
  }
  e.target.name = e.target.id.substr(0, e.target.id.indexOf('-option'));
  onChange(e,'tiers')

}
const classes = useStyles();

return (
    <React.Fragment>
      {
        (display)
            ?
              <React.Fragment>
                <div className="row">
                  <div className="col-12">
                    <Typography variant="body2" className="mt-2">
                      {title}
                    </Typography>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    {(tier.tier_variation_id === '0' || tier.tier_variation_id === 0)
                      ?
                        <React.Fragment>
                          <FormControl className="" style={{fontSize: '0.75rem'}} name={tier.tier_type_id + ".tier_variation_brand_id"} >Marca
                            <Select native name={tier.tier_type_id + ".tier_variation_brand_id"}
                                inputProps={{
                                  name:tier.tier_type_id + ".tier_variation_brand_id",
                                  className:"tier_variation_brand_id"
                                }}
                                style={{minwidth: 120, fontSize: '0.75rem'}}
                                disabled={disabled}
                                value={tier.tier_variation_brand_id}
                                onChange={handleChange}
                                input={<Input id="grouped-native-select" name={tier.tier_type_id + '.tier_variation_brand_id'}/>}>
                                <option value="" />
                                {tier_brands.map((brand) =>
                                    <option id={brand.id} value={brand.id}>{brand.name}</option>
                                )}
                            </Select>
                          </FormControl>                        
                          <TextField
                            id={tier.tier_type_id + ".tier_variation_name"}
                            name={tier.tier_type_id + ".tier_variation_name"}
                            label="Nombre"
                            disabled={disabled}
                            type="text"
                            placeholder="Ingrese el nombre"
                            onChange={handleChange}
                            value={tier.tier_variation_name}
                            margin="none"
                            className="mr-2 "
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{style:{fontSize: '0.75rem'}}} 
                          />
                          <TextField
                            id={tier.tier_type_id + ".tier_variation_anchor"}
                            name={tier.tier_type_id + ".tier_variation_anchor"}
                            label="Ancho"
                            disabled={disabled}
                            type="number"
                            placeholder="Ingrese el anchor"
                            onChange={handleChange}
                            value={tier.tier_variation_anchor}
                            margin="none"
                            className="mr-2 "
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{style:{fontSize: '0.75rem'}}} 
                          />      
                          <TextField
                            id={tier.tier_type_id + ".tier_variation_size"}
                            name={tier.tier_type_id + ".tier_variation_size"}
                            label="Perfil"
                            disabled={disabled}
                            type="number"
                            placeholder="Ingrese el perfil"
                            onChange={handleChange}
                            value={tier.tier_variation_size}
                            margin="none"
                            className="mr-2 "
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{style:{fontSize: '0.75rem'}}} 
                          />                                                  
                          <TextField
                            id={tier.tier_type_id + ".tier_variation_wheel"}
                            name={tier.tier_type_id + ".tier_variation_wheel"}
                            label="Rodado"
                            disabled={disabled}
                            type="number"
                            placeholder="Ingrese el rodado"
                            onChange={handleChange}
                            value={tier.tier_variation_wheel}
                            margin="none"
                            className="mr-2 "
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{style:{fontSize: '0.75rem'}}} 
                          />                                                  

                                            
                        </React.Fragment>
                      :
                              <FormControlLabel
                                className="mx-0 my-0"
                                style={{alignItems: 'baseline'}}
                                label={<Typography variant="caption" style={{width: 75}}>Modelo </Typography>}
                                labelPlacement="start"
                                control={
                                  <Autocomplete
                                    id={tier.tier_type_id + ".tier_variation_id"}
                                    style={{ width: 225, marginLeft:8 }}
                                    getOptionLabel={(variation) => (variation.id > 0) ? variation.brand.name +" "+variation.name+"-"+variation.anchor+"x"+variation.wheel+"x"+variation.size : variation.name}
                                    getOptionSelected={(variation, value) => variation.id === value}			      
                                    options={tier_variations}
                                    onChange={handleTierChange}
                                    autoComplete
                                    //defaultValue={(tier.tier_variation_id) ? tier.tier_variation_id : null}
                                    value={(tier.tier_variation_id) ? tier_variations.find(v => v.id === tier.tier_variation_id) || null : null}
                                    noOptionsText={<Typography variant="caption">Sin resultados</Typography>}
                                    name={tier.tier_type_id + ".tier_variation_id"}
                                    includeInputInList
                                    classes={{
                                      option: classes.option,
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Modelo"
                                        id={tier.tier_type_id + ".tier_variation_id"}
                                        name={tier.tier_type_id + ".tier_variation_id"}
                                        autoComplete="off"
                                        FormHelperTextProps={{
                                          className: classes.helperText
                                        }}
                                        InputProps={{
                                          ...params.InputProps,
                                          endAdornment: (
                                          <React.Fragment>
                                            {params.InputProps.endAdornment}
                                          </React.Fragment>
                                          ),
                                        }}
                                        InputLabelProps={{ 
                                                  shrink: true
                                                }}
                                        inputProps={{
                                              ...params.inputProps,
                                              autoComplete:tier.tier_type_id +".tier_variation_id",
                                              style:{fontSize: '0.75rem', width: 225},
                                            }}

                                      />
                                    )}
                                  />		
                                  }
                                />	                              
                    }
                  </div>
                </div>
                <div className="row mt-1">
                  <div className="col-12">
                    <TextField
                      id={tier.tier_type_id + ".date_change"}
                      name={tier.tier_type_id + ".date_change"}
                      label="Fecha del cambio"
                      disabled={disabled}
                      type="date"
                      placeholder="Ingrese la fecha del cambio"
                      onChange={handleChange}
                      value={tier.date_change}
                      margin="none"
                      className="mr-2 "
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{style:{minwidth: 120, fontSize: '0.75rem'}}} 
                    />
                  </div>
                </div>
              </React.Fragment>
            :
              ''
      }
    </React.Fragment>
    )
}

Tier.defaultProps = {
  inline: false,
  display: true,
  display_next_fields:true
}

export default Tier;

